import React, { useEffect, useState } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import authorizedComponent from "../../../helpers/authorized-component";
import UnAuthorized from "../../partials/other/UnAuthorized";

function AllPermission() {
  let [htmlTag, setHtmlTag] = useState();

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    let permissions = await sendRequest();

    if (!permissions) {
      return;
    }
    setHtmlTag(generatehtmlTagPermissions(permissions.data.data));
  }

  const sendRequest = async () => {
    const headersRequest = getHeaderForRequset();

    try {
      return await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/permission",
        headersRequest
      );
    } catch (error) {
      return false;
    }
  };

  const generatehtmlTagPermissions = (permissions) => {
    return permissions.map((permission, index) => {
      const linkEdit = "/permission/edit/" + permission.per_id;

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{permission.per_id}</td>
          <td>{permission.per_name}</td>
          <td>{permission.per_persian_name}</td>
          <td>{permission.per_created_at}</td>

          <td>
            <div>
              <span className="pl-2">
                <Link className="btn btn-outline-success  " to={linkEdit}>
                  <i className="fa fa-edit"></i>
                </Link>
              </span>

              <span>
                <span
                  className="btn btn-outline-danger  btn-danger"
                  onClick={() => deletePermission(permission.per_id)}
                >
                  <i className="fa fa-trash"></i>
                </span>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const deletePermission = async (permissionID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    const headersRequest = getHeaderForRequset();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/permission/" + permissionID,
        headersRequest
      );

      getPermissions();
    } catch (error) {
      alert(error.response.data.message);
    }
  };

  return (
    <>
      <Sidebar openItem="role-permission" activeItem="permission-all" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">دسترسی ها</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-3">
                <Link className="btn btn-outline-info" to="/permission/add">
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>دسترسی جدید</span>
                </Link>
              </div>
              <div className="alert alert-warning">
                <span className="pl-2">
                  <i className="fa fa-exclamation-triangle	"></i>
                </span>
                <span>حد امکان از تغییر و ویرایش نام دسترسی خودداری کنید.</span>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-dark tbl-td-white-space ">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره دسترسی</td>
                      <td>نام دسترسی</td>
                      <td>نام فارسی</td>
                      <td>تاریخ ایجاد</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>

                  <tbody>{htmlTag}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPermission;
